import React, { FunctionComponent, useMemo, useSyncExternalStore } from "react";

import { MarketInfo } from "@gamedev-web/gamedev-sdk-core";
import { MessageProvider } from "@messageformat/react";

import { PartnerConfigManager } from "../partners";
import { getResourceStringsAsync } from "./getResourceStringsAsync";

export const makeResourceStringContextProviderAsync = async <
  Props extends { children: React.ReactNode },
>(
  marketInfo: MarketInfo,
  partnerConfigManager: PartnerConfigManager
): Promise<FunctionComponent<Props>> => {
  const baseStrings = await getResourceStringsAsync(marketInfo);

  return (props: Props) => {
    useSyncExternalStore(
      partnerConfigManager.subscribe,
      partnerConfigManager.getClientState,
      partnerConfigManager.getServerState
    );

    // This will update on navigation.
    const partnerResourceStrings = partnerConfigManager.getPartnerResources();

    const messages = useMemo(
      () => ({
        baseStrings,
        ...partnerResourceStrings,
      }),
      [partnerResourceStrings]
    );

    return <MessageProvider messages={messages} {...props} />;
  };
};
